import Button, { BUTTON_HEIGHT_32 } from '../../../../Button'
import { FloatingTooltip } from '../../../../Floating'
import { ICON_HEIGHT_16 } from '../../../../Icon'

function RentalPortalPhotoGalleryTileOverlayActionsButton({
  Icon,
  disabled,
  isGrey = true,
  qaName,
  tooltip,
  onClick,
}) {
  return (
    <FloatingTooltip content={tooltip}>
      <Button.White
        beforeIconProps={{ Icon, height: ICON_HEIGHT_16 }}
        disabled={disabled}
        height={BUTTON_HEIGHT_32}
        isGrey={isGrey}
        qaName={qaName}
        onClick={onClick}
      />
    </FloatingTooltip>
  )
}

export default RentalPortalPhotoGalleryTileOverlayActionsButton
